import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing auth token on mount
    const token = localStorage.getItem('authToken');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const signup = async (email, password, orgName, organisationType) => {
    try {
      const result = await api.signup(email, password, orgName, organisationType);
      localStorage.setItem('authToken', result.access_token);
      localStorage.setItem('user', JSON.stringify(result.user));
      setUser(result.user);
      return { success: true, user: result.user, message: 'Account created successfully!' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  };

  const login = async (email, password) => {
    try {
      const result = await api.login(email, password);
      localStorage.setItem('authToken', result.access_token);
      localStorage.setItem('user', JSON.stringify(result.user));
      setUser(result.user);
      return { success: true, user: result.user, message: 'Login successful!' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, signup, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
